import { ICellTypeHandler } from "components/grecoreactgrid/ICellTypeHandler";
import { ImportedInvoiceOptionsCellTemplate } from "../customcells/ImportedInvoiceOptionsCellTemplate";

// Re-match / delete icons of a row. On a ticked row they act on every ticked row at once
// (like "Invalidate" on the Payments page); on an unticked row only on that row.
class ImportedInvoiceOptionsCellTypeHandler implements ICellTypeHandler {
  cellType = "importedinvoiceoptions";
  isCustom = true;
  instance = new ImportedInvoiceOptionsCellTemplate();
  determineNewValue = (change: any) => {
    return (change.newCell as any).text;
  };
  getEntryRow = (
    entry: any,
    columnConfig: any,
    rowsMetadataMap: any,
    keyColumn: string,
    context: {
      [key: string]: any;
    }
  ) => {
    const [, { setImportedInvoicesStoreValues }] =
      context["importedInvoicesStore"];
    const { t } = context;

    const rowId = columnConfig.additionalInfo?.rowIdField
      ? entry[columnConfig.additionalInfo.rowIdField]
      : "";
    const selected = rowsMetadataMap[entry[keyColumn]]?.selected ?? false;
    const selectedIds: number[] = Object.entries(rowsMetadataMap)
      .filter((e: any) => e[1].selected)
      .map((e: any) => Number(e[0]));
    // the ids the icons of this row act on
    const targetIds = selected && selectedIds.length > 1 ? selectedIds : [rowId];

    return {
      type: "importedinvoiceoptions",
      rowId,
      selected,
      highlighted: rowsMetadataMap[entry[keyColumn]]?.highlighted ?? false,
      targetCount: targetIds.length,
      matchFn: () => {
        setImportedInvoicesStoreValues({
          rematchImportedInvoicesDialog: {
            isOpen: true,
            importedInvoiceIds: targetIds,
          },
        });
      },
      deleteFn: () => {
        setImportedInvoicesStoreValues({
          deleteImportedInvoiceDialog: {
            isOpen: true,
            importedInvoiceIds: targetIds,
          },
        });
      },
      t,
    };
  };
}

export default ImportedInvoiceOptionsCellTypeHandler;
